import { client } from "./defaultClient";
import { Activity } from "./generated";

export const getActivities = async (): Promise<Activity[]> =>
    await client.getActivities({ mode: "cors" });
